import { Controller } from 'stimulus'

/**
 * Shows/hides an empty-state element when turbo streams remove the last item
 * from a list. Reusable across features.
 *
 * Markup (Stimulus 1 — use data-item-selector, not Stimulus 2 values):
 *   data-controller="empty-state"
 *   data-item-selector=".my-item-class"
 *   data-target="empty-state.list"   — container of removable items
 *   data-target="empty-state.empty"  — empty-state element (toggled via hidden)
 */
export default class extends Controller {
  static targets = ['list', 'empty']

  connect() {
    this.onBeforeStreamRender = this.onBeforeStreamRender.bind(this)
    document.addEventListener('turbo:before-stream-render', this.onBeforeStreamRender)
  }

  disconnect() {
    document.removeEventListener('turbo:before-stream-render', this.onBeforeStreamRender)
  }

  onBeforeStreamRender(event) {
    const originalRender = event.detail.render

    event.detail.render = async (streamElement) => {
      const affectsList = this.streamRemovesListItem(streamElement)
      await originalRender(streamElement)
      if (affectsList) this.toggleEmptyState()
    }
  }

  streamRemovesListItem(streamElement) {
    if (streamElement.action !== 'remove') return false
    if (!this.hasListTarget) return false

    const targetId = streamElement.getAttribute('target')
    if (!targetId) return false

    return Boolean(this.listTarget.querySelector(`[id="${targetId}"]`))
  }

  toggleEmptyState() {
    if (!this.hasListTarget || !this.hasEmptyTarget) return

    const selector = this.itemSelector
    if (!selector) return

    this.emptyTarget.hidden = this.listTarget.querySelector(selector) !== null
  }

  get itemSelector() {
    return this.element.dataset.itemSelector
  }
}
